import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmpresaService } from '../services/empresa.service';
import { Constants } from '../../../constants/constants';
import { ParametrosRespuestaDto } from '../../../dto/auth/autenticacion-digital.dto';

@Component({
  selector: 'app-pasos-seguir',
  templateUrl: './pasos-seguir.component.html',
  styleUrl: './pasos-seguir.component.scss'
})
export class PasosSeguirComponent implements OnInit {
  textoPasosCreacionEmpresa!: ParametrosRespuestaDto;

  constructor(
    private router: Router,
    private readonly empresaService: EmpresaService
  ) {
  }

  ngOnInit(): void {
    this.getTextoPasos();
  }

  getTextoPasos() {
    const body = {
      pagina: 1,
      tamanoPagina: 10,
      ordenarPor: Constants.DESCRIPCION,
      ordenarAsc: true,
      filtros: {
        nombre_parametro: Constants.PROCESO_CREACION_EMPRESA
      }
    };
    this.empresaService.parametrizacionPasosEmpresa(body).subscribe((response: any) => {
      this.textoPasosCreacionEmpresa = response;
    })
  }

}